<template>
<div class="rental-price" >
<md-switch v-model="inputAvailable" v-if="rentalVideo"></md-switch>

<md-input-container >
        <label for="price">Rental price</label>
        <md-select v-model="selectedOption" :disabled=!inputAvailable @input="emitSelection">
            <md-option v-for="option in prices" :value="option" :key='option'>
                $ {{ formatPrice(option) }}
            </md-option>
        </md-select>
</md-input-container>
</div>
</template>

<script>

export default {
props: {
    rentalVideo: {
    type: Boolean,
    default: false
    },
    price: {
    type: Number,
    },
},
data() {
    return {
    selectedOption: null,
    inputAvailable: true,
    prices: [],
    };
},
methods: {
    formatPrice(amount) {
        return (amount / 100).toFixed(2);
    },
    emitSelection() {
        this.$emit('price-selected', this.selectedOption);
    },
    generatePrices(){
        for (let i = 99; i <= 1999; i+=100) {
            this.prices.push(i);
        }
    }
},


mounted() {
    this.generatePrices();
    if(this.price) { this.selectedOption = this.price }
},

watch: {
    price(newPrice) {
        if (newPrice) {
            this.selectedOption = newPrice;
            this.emitSelection();
        }
    }
}
};
</script>

<style lang="scss" scoped>
.rental-price {
    display: flex;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/RentalPricingForm.vue